import { RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuestionCardError {
  retry: () => void;
}

export const QuestionCardError = ({ retry }: QuestionCardError) => {
  return (
    <div className="md:h-[180px] border bg-muted/40 p-4 rounded-2xl w-full grid place-items-center">
      <div className="flex flex-col items-center gap-4">
        <p className="text-destructive">
          Error loading questions. Please try again.
        </p>
        <Button variant="outline" onClick={retry}>
          <RefreshCcw className="mr-2 h-4 w-4" /> Retry
        </Button>
      </div>
    </div>
  );
};
